import PrimaryButton from "Components/atoms/buttons/primary-button";
import styled from "styled-components";
import { ConstructionIcon } from "Components/atoms/icons";

const WorkInProgressStateContainer = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 40px 60px;
   text-align: center;
   gap: 12px;

   > div {
    font-size: 48px
    }
`

interface WorkInProgressStateProps {
    title: string;
    subtitle: string;
    buttonText?: string
    onClickButton?: () => any
}

const WorkInProgressState: React.FC<WorkInProgressStateProps> = ({ title, subtitle, buttonText, onClickButton }) => {
    return (
        <WorkInProgressStateContainer>
            <div><ConstructionIcon className="text-warning" /></div>
            <h6 >
                {title}
            </h6>
            <body>
                {subtitle}
            </body>
            {buttonText && onClickButton && <PrimaryButton onClick={() => {
                onClickButton()
            }}>
                {buttonText}
            </PrimaryButton>}
        </WorkInProgressStateContainer>
    )
}

export default WorkInProgressState;